class OrderConfirmationPanelController {
    $onInit() {
        this.status = 'loading';
        this.confirmation = this.order;
        // Todo: unwrap confirmation so that we're just dealing with the order :/
        this.orderCancelled = this.order.Order.OrderStatus === 'Cancelled';
        if (this.confirmation) {
            this.status = 'ordercomfirmation';
        }
    }
}

const orderConfirmationPanelControllerComponentDefinition = {
    bindings: {
        order: '=',
        saveCard: '=',
    },
    controller: OrderConfirmationPanelController,
    template: require('./order-confirmation-panel.component.html').trim(),
};

module.exports = {
    OrderConfirmationPanelController,
    orderConfirmationPanelControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-panel.component.js